<div class="d-flex flex-column flex-root h-100">
    <div class="login login-3 login-signin-on d-flex flex-column flex-lg-row flex-row-fluid bg-white" id="kt_login"
         style="background-image: url('./assets/media/bg/mad_login.jpg');">
        <router-outlet></router-outlet>
    </div>
</div>
